import "../messageStyles.css";
import OptionMenu from "../OptionMenu";
import { Lock, Satellite } from "lucide-react";
import LocationLink from "../LocationLink";

interface ReceivedTextMessageProps {
  id: number;
  created: string;
  time: string;
  msg: string;
  isEncrypted?: boolean;
  isKeyExchange?: boolean;
  senderUsername?: string;
  isSatellite?: boolean;
  lat?: string;
  lng?: string;
}

const ReceivedTextMessage = ({
  id,
  created,
  time,
  msg,
  isEncrypted,
  isKeyExchange,
  senderUsername,
  isSatellite,
  lat,
  lng,
}: ReceivedTextMessageProps) => {

  if (isKeyExchange) {
    return (
      <div key={id} className="message-container group">
        <div className="items-start message-time-container">
          <span className="message-time">{created ? time : "now"}</span>
          <div className="options-menu">
            <div className="message-text-container received-color opacity-70 italic">
              <p className="message-text">{msg}</p>
            </div>
            <OptionMenu/>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div key={id} className="message-container group">
      <div className="items-start message-time-container">
        <div className="flex items-center gap-2">
          {senderUsername && (
            <span className="text-xs font-semibold text-neutral-500">{senderUsername}</span>
          )}
          <span className="message-time">{created ? time : "now"}</span>
        </div>
        <div className="options-menu">
          <div className="message-text-container received-color">
            <p className="message-text">
              {msg}
            </p>
          </div>
          {isEncrypted && (
            <Lock size={12} className="text-green-500 shrink-0" />
          )}
          {isSatellite && (
            <Satellite size={15} className="text-blue-400 shrink-0" />
          )}
          <OptionMenu/>
        </div>
        <LocationLink lat={lat} lng={lng} />
      </div>
    </div>
  );
};

export default ReceivedTextMessage;
